export default defineNuxtRouteMiddleware(async (to, from) => {
  const publicRoutes = [
    "/",
    "/login",
    "/logout",
    "/registration",
    "/profile-builder",
    "/verify-email",
    "/onboarding",
    "/forgot-password",
    "/verify-email",
    "/profile-error",
  ];

  // skip middleware on server
  if (import.meta.server) return;

  if (publicRoutes.includes(to.path)) {
    return;
  }

  const user = await getCurrentUser();

  // Also check local storage
  const localUser = localStorage.getItem("user");
  if (!user || !localUser) {
    console.log("user not logged in");
    return navigateTo("/login");
  }

  return;
});
